var _rect, _rect2, _rect3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDraft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12,
    fill: "url(#paint0_linear_1605_12440)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12,
    fill: "url(#paint1_linear_1605_12440)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12,
    fill: "url(#paint2_linear_1605_12440)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1605_12440)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 20H24C22.9391 20 21.9217 20.4214 21.1716 21.1716C20.4214 21.9217 20 22.9391 20 24V36C20 37.0609 20.4214 38.0783 21.1716 38.8284C21.9217 39.5786 22.9391 40 24 40H26.9L31.351 43.763C31.5316 43.9158 31.7605 43.9997 31.997 43.9997C32.2335 43.9997 32.4624 43.9158 32.643 43.763L37.1 40H40C41.0609 40 42.0783 39.5786 42.8284 38.8284C43.5786 38.0783 44 37.0609 44 36V24C44 22.9391 43.5786 21.9217 42.8284 21.1716C42.0783 20.4214 41.0609 20 40 20ZM42 36C42 36.5304 41.7893 37.0391 41.4142 37.4142C41.0391 37.7893 40.5304 38 40 38H37.1C36.6273 38.0001 36.1699 38.1677 35.809 38.473L32 41.69L28.193 38.473C27.8316 38.1673 27.3734 37.9997 26.9 38H24C23.4696 38 22.9609 37.7893 22.5858 37.4142C22.2107 37.0391 22 36.5304 22 36V24C22 23.4696 22.2107 22.9609 22.5858 22.5858C22.9609 22.2107 23.4696 22 24 22H40C40.5304 22 41.0391 22.2107 41.4142 22.5858C41.7893 22.9609 42 23.4696 42 24V36Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 27H32C32.2652 27 32.5196 26.8946 32.7071 26.7071C32.8946 26.5196 33 26.2652 33 26C33 25.7348 32.8946 25.4804 32.7071 25.2929C32.5196 25.1054 32.2652 25 32 25H27C26.7348 25 26.4804 25.1054 26.2929 25.2929C26.1054 25.4804 26 25.7348 26 26C26 26.2652 26.1054 26.5196 26.2929 26.7071C26.4804 26.8946 26.7348 27 27 27Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 29H27C26.7348 29 26.4804 29.1054 26.2929 29.2929C26.1054 29.4804 26 29.7348 26 30C26 30.2652 26.1054 30.5196 26.2929 30.7071C26.4804 30.8946 26.7348 31 27 31H37C37.2652 31 37.5196 30.8946 37.7071 30.7071C37.8946 30.5196 38 30.2652 38 30C38 29.7348 37.8946 29.4804 37.7071 29.2929C37.5196 29.1054 37.2652 29 37 29Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 33H27C26.7348 33 26.4804 33.1054 26.2929 33.2929C26.1054 33.4804 26 33.7348 26 34C26 34.2652 26.1054 34.5196 26.2929 34.7071C26.4804 34.8946 26.7348 35 27 35H37C37.2652 35 37.5196 34.8946 37.7071 34.7071C37.8946 34.5196 38 34.2652 38 34C38 33.7348 37.8946 33.4804 37.7071 33.2929C37.5196 33.1054 37.2652 33 37 33Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1605_12440",
    x1: 32,
    y1: 0,
    x2: 32,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3D45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1605_12440",
    x1: 32,
    y1: 0,
    x2: 32,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63B967"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4BA64F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1605_12440",
    x1: 32,
    y1: 0,
    x2: 32,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#439DEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E78E9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1605_12440"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(20 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraft);
export default __webpack_public_path__ + "static/media/draft.69eeb7af78bba241e2135bd617201665.svg";
export { ForwardRef as ReactComponent };